export default "__VITE_ASSET__BVXIlrFT__"